import { MutationTree } from 'vuex';
import {
  EmailDetailItem,
  EmailDetailEventsItem,
  EmailGroupEventsType,
  EmailGroupItem,
  StatisticState
} from './types';

export const mutations: MutationTree<StatisticState> = {
  setEmailStatisticDetail: (state, data: EmailDetailItem[]) => {
    state.emailStatisticDetail = data;
  },
  pushEmailStatisticDetail: (state, data: EmailDetailItem[]) => {
    state.emailStatisticDetail = state.emailStatisticDetail.concat(data);
  },
  setEmailStatisticDetailFlag: (state, flag: string) => {
    state.emailStatisticDetailFlag = flag;
  },
  setEmailStatisticGroup: (state, data: EmailGroupItem[]) => {
    state.emailStatisticGroup = data;
  },
  setEmailStatisticGroupEvents: (state, data: EmailGroupEventsType) => {
    state.emailStatisticGroupEvents = data;
  },
  setMessagesCount: (state, count: number) => {
    state.emailMessageCount = count;
  },
  setEmailDetailEvents: (state, data: EmailDetailEventsItem[]) => {
    state.emailDetailEvents = data;
  }
};
